module.exports = __webpack_public_path__ + "LatoLatin-Black.3dc3ee7177ed30347e19.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Black.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Black.ttf
// module chunks = styles